import React from "react";
import Hidden from "@material-ui/core/Hidden";
import GridContainer from "./Grid/GridContainer";
import GridItem from "./Grid/GridItem";
import PropTypes from "prop-types";
import Button from "./CustomButtons/Button";
import Print from "@material-ui/icons/Print";
import Table from "./Table/Table";
import Span from "./Typography/Span";
import SpanH2 from "./Typography/SpanH2";
import {primaryColor} from "../assets/jss/material-dashboard-pro-react";
import ReactTable from "react-table";
import {Filter, formataCPFCNPJ, somenteNumero} from "./Funcoes";
import {traducaoReactTable} from "./DataModule";
import matchSorter from "match-sorter";
import IconButton from "@material-ui/core/IconButton";
import InputBase from "@material-ui/core/InputBase";
import {Search} from "@material-ui/icons";
import Paper from "@material-ui/core/Paper";

const FilterOnlyNumber = ({filter, onChange}) => Filter({filter, onChange}, somenteNumero);

class ResponsiveTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      colunas: [],
      dados: [],
      filtro: ""
    };
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const {colunas, dados} = nextProps;
    if (colunas) this.setState({colunas});
    if (dados) this.setState({dados});
  }

  componentDidMount() {
    const {colunas, dados} = this.props;
    if (colunas) this.setState({colunas});
    if (dados) this.setState({dados});
  }

  getChildrenComponentText(component) {
    if (component || parseInt(component) === 0) {
      if (["string", "number"].indexOf(typeof component) !== -1) {
        return component;
      } else if (typeof component === "object") {
        const {props} = component;
        if (props) {
          const {children} = props;
          if (children)
            return this.getChildrenComponentText(children);
        }
      }
    }
  }

  imprimir() {
    // let modeloTabela = "<style></style>";
    let modeloTabela = `<style>td{border: 1px solid ${primaryColor[6]};}body{background-color:#91ced4}body *{box-sizing:border-box}.header{background-color:${primaryColor[0]};color:#fff;font-size:1.5em;padding:1rem;text-align:center;text-transform:uppercase}img{border-radius:50%;height:60px;width:60px}.table-users{border:1px solid ${primaryColor[4]};border-radius:10px;box-shadow:3px 3px 0 rgba(0,0,0,.1);max-width:calc(100% - 2em);margin:1em auto;overflow:hidden;width:800px}table{width:100%}table td,table th{color:#2b686e;padding:10px}table td{text-align:center;vertical-align:middle}table td:last-child{font-size:.95em;line-height:1.4;text-align:left}table th{background-color:#daeff1;font-weight:300}table tr:nth-child(2n){background-color:#fff}table tr:nth-child(2n+1){background-color:#edf7f8}@media screen and (max-width:700px){table,td,tr{display:block}td:first-child{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:100px}td:not(:first-child){clear:both;margin-left:100px;padding:4px 20px 4px 90px;position:relative;text-align:left}td:not(:first-child):before{color:#91ced4;content:'';display:block;left:0;position:absolute}td:nth-child(2):before{content:'Name:'}td:nth-child(3):before{content:'Email:'}td:nth-child(4):before{content:'Phone:'}td:nth-child(5):before{content:'Comments:'}tr{padding:10px 0;position:relative}tr:first-child{display:none}}@media screen and (max-width:500px){.header{background-color:transparent;color:#fff;font-size:2em;font-weight:700;padding:0;text-shadow:2px 2px 0 rgba(0,0,0,.1)}img{border:3px solid;border-color:#daeff1;height:100px;margin:.5rem 0;width:100px}td:first-child{background-color:#c8e7ea;border-bottom:1px solid #91ced4;border-radius:10px 10px 0 0;position:relative;top:0;-webkit-transform:translateY(0);transform:translateY(0);width:100%}td:not(:first-child){margin:0;padding:5px 1em;width:100%}td:not(:first-child):before{font-size:.8em;padding-top:.3em;position:relative}td:last-child{padding-bottom:1rem!important}tr{background-color:#fff!important;border:1px solid #6cbec6;border-radius:10px;box-shadow:2px 2px 0 rgba(0,0,0,.1);margin:.5rem 0;padding:0}.table-users{border:none;box-shadow:none;overflow:visible}}</style>`;
    modeloTabela += `<style>tr {page-break-inside: avoid !important;}</style>`;
    modeloTabela += `<title>${this.props.titlePrint || ':: Relatório Gefis ::'}</title>`;
    const {onPrint} = this.props;
    if (onPrint) {
      onPrint(this.state.dados);
      return true;
    }
    const contrato = window.open('', '', 'height=595,width=841');

    modeloTabela += "<table style='width: 100%'>";
    modeloTabela += "    <tr>";
    this.state.colunas.map(prop => {
      modeloTabela += "<th>";
      modeloTabela += `    <Span color={"${primaryColor[0]}"}>${prop}</Span>`;
      modeloTabela += "</th>";
      return null;
    });

    this.state.dados.sort((a, b) => {
      if (a[this.props.printOrder].impressao > b[this.props.printOrder].impressao)
        return 1;
      else if (a[this.props.printOrder].impressao < b[this.props.printOrder].impressao)
        return -1;
      return 0;
    }).map(prop => {
      modeloTabela += `<tr>`;
      prop.map(prop1 => {
        modeloTabela += `<td style="text-align: center">`;
        if (prop1) {
          const {impressao} = prop1;
          if (impressao)
            prop1 = impressao;
        }
        const componente = this.getChildrenComponentText(prop1);
        modeloTabela += parseInt(componente) === 0 ? "0" : (componente || "");
        modeloTabela += `</td>`;
        return null;
      });
      modeloTabela += `</tr>`;
      return null;
    });

    modeloTabela += "    </tr>";
    modeloTabela += "</table>";

    contrato.document.write(modeloTabela);
    contrato.document.close();
    contrato.print();
  }

  filtrarDados(dados, filtro) {
    let tempRegistros = [];
    for (let i = 0; i < dados.length; i++) {
      for (let j = 0; j < dados[i].length; j++) {
        const valor = this.getChildrenComponentText(dados[i][j]);
        if ((valor || "").toString().toLowerCase().indexOf(filtro) > -1)
          tempRegistros.push(i);
      }
    }

    return tempRegistros.filter((este, i) => tempRegistros.indexOf(este) === i).map(prop => dados[prop]);
  }

  render() {
    return (
      <div>
        <SpanH2>
          {this.props.title}
        </SpanH2>
        <Button
          color={"info"}
          style={{float: 'right', marginTop: -10}}
          simple
          onClick={this.imprimir.bind(this)}
        >
          <Print/> {this.props.label || "Imprimir"}
        </Button>
        {this.props.actions ? this.props.actions.map((prop, key) => (
          <Button key={key} color={"info"} style={{float: 'right', marginTop: -10}} simple onClick={prop.action}>
            {prop.label}
          </Button>
        )) : ""}
        <br/><br/>
        <Hidden smDown>
          {this.props.normalTable ? (
            <div align="right">
              <Paper component="form" style={{padding: '2px 4px', display: 'flex', alignItems: 'center', width: 400}}>
                <InputBase
                  style={{flex: 1,}}
                  placeholder="Pesquisar"
                  inputProps={{'aria-label': 'Pesquisar'}}
                  onChange={({target: {value}}) => {
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                      this.setState({filtro: value});
                    }, 800);
                  }}
                />
                <IconButton aria-label="Pesquisar" style={{padding: 10}}>
                  <Search/>
                </IconButton>
              </Paper>
              <br/>
              <Table
                tableHead={this.state.colunas}
                hover
                tableData={this.filtrarDados(this.state.dados, this.state.filtro).map(prop => {
                  return prop.map(prop1 => {
                    if (prop1) {
                      const {data} = prop1;
                      if (data)
                        prop1 = data;
                    }
                    return prop1;
                  });
                })}
              />
            </div>
          ) : (
            <ReactTable
              {...traducaoReactTable}
              getTrProps={(state, rowInfo) => (rowInfo && rowInfo.original['c_6'] === 'Cancelada') ? {style: {background: 'rgba(255,0,0,0.1)'}} : {}}
              columns={Array.isArray(this.state.colunas) ? this.state.colunas.map((prop, key) => {
                const op = typeof prop !== 'string' || ['opções', 'status', ""].indexOf(prop.toLowerCase()) === -1;
                if ((typeof prop === 'string' && prop.toLowerCase() !== "cnpj") || typeof prop !== 'string')
                  return {
                    Header: prop,
                    accessor: `c_${key}`,
                    Filter,
                    filterable: op,
                    sortable: op
                  };
                else
                  return {
                    Header: prop,
                    accessor: `c_${key}`,
                    filterable: true,
                    Cell: ({value}) => formataCPFCNPJ(value),
                    Filter: FilterOnlyNumber
                  };
              }) : this.state.colunas}
              data={this.state.dados.map(prop => {
                const dados = {};
                prop.map((prop1, key) => {
                  if (prop1) {
                    const {data} = prop1;
                    prop1 = data ? data : prop1;
                  }
                  dados[`c_${key}`] = prop1;
                });
                return dados;
              })}
              filterable
              defaultFilterMethod={(filter, row) => matchSorter([row[filter.id]], filter.value, {threshold: matchSorter.rankings.WORD_STARTS_WITH}).length !== 0}
              defaultPageSize={10}
              showPaginationBottom={true}
              className="-striped -highlight"
            />
          )}
        </Hidden>
        <Hidden mdUp>
          {this.state.dados.map((prop, key) => {
            return (
              <GridContainer key={key}>
                {prop.map((prop1, key1) => {
                  if (prop1) {
                    const {data} = prop1;
                    if (data)
                      prop1 = data;
                  }
                  return (
                    <GridItem lg={12} md={12} sm={12} xs={12} key={key1} style={{textAlign: 'center'}}>
                      <Span style={{fontSize: '0.6rem'}} mainColor>
                        {this.state.colunas[key1]}
                      </Span>
                      <Span
                        simple
                        lower={[true, false].indexOf(this.props.lower) !== -1 ? this.props.lower : false}
                      >
                        {prop1}
                      </Span>
                    </GridItem>
                  );
                })}
                <GridItem lg={12} md={12} sm={12} xs={12}>
                  <hr style={{backgroundColor: primaryColor[0], height: 1}}/>
                </GridItem>
              </GridContainer>
            );
          })}
        </Hidden>
      </div>
    );
  }
}

ResponsiveTable.propTypes = {
  colunas: PropTypes.object,
  dados: PropTypes.object,
  lower: PropTypes.bool,
  normalTable: PropTypes.bool,
  printOrder: PropTypes.bool,
  title: PropTypes.string,
  titlePrint: PropTypes.string,
};

export default ResponsiveTable;
